import React, { useEffect, useState } from "react";
import { useObserver } from "mobx-react";
import { AiFillCloseCircle, AiFillPlusCircle } from "react-icons/ai";
import { useStores } from "../../store";
import { MdMailOutline } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { apiPostPut } from "../../api/api_methods";
import { sendMultipleEmails } from "../../api/recruiterDashboardApi";
import LoaderForApplicants from "../reusble_components/loaderForApplications";
export default function MailPopUp2(props) {
  const { PopupStore, UserStore, RecuiterStore } = useStores();
  const [emailList, setEmailList] = useState(props.emails);
  const [cc, setCc] = useState([
    JSON.parse(localStorage.getItem("user"))?.mail || "",
  ]);
  const navigate = useNavigate();
  const [form, setform] = useState(false);
  const [fileName1, setFileName1] = useState("");
  const { id } = useParams();
  const [url, seturl] = useState("");
  const [loader2, setLoader2] = useState(false);
  const [close, setClose] = useState("");
  const [ccClose, setCcClose] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicantId = queryParams.get("applicant");
  useEffect(() => {
    setEmailList(props.emails);
  }, [props.emails]);

  const closeThisPopUP = () => {
    setform(false);
    setFileName1("");
    seturl("");
    PopupStore.setMail2(false);
  };

  return useObserver(() => (
    <>
      {PopupStore.mail2 ? (
        <div className="absolute w-full h-full z-30 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-10">
          <div className="fixed  inset-0 bg-[#FFFFFF] z-30 flex flex-col justify-center rounded-xl items-center md:w-[65%] lg:w-[60%] w-[95%] h-[90%] md:h-[95%] lg:h-[95%] m-auto overflow-y-auto no-scrollbar">
            <form
              className="flex flex-col items-center  h-full py-4 w-[100%] md:w-[100%] lg:[100%] "
              onSubmit={async (e) => {
                e.preventDefault();
                setLoader2(true);
                const body = {
                  mails: emailList,
                  cc: cc,
                  subject: e.target.sub.value,
                  text: e.target.message.value,
                };
                // console.log(body)
                const response = await sendMultipleEmails(body);
                if (response.status === 200) {
                  setLoader2(false);
                  await RecuiterStore.updateApplicantMailDetails(
                    RecuiterStore.jobPostApplicant?._id,
                    props.statusNumber ?? 9,
                    e.target.sub.value,
                    e.target.message.value,
                    true,
                    RecuiterStore.jobPostApplicant?.mailDetails,
                  );
                  if (props.interview) {
                    props.onSent();
                    return;
                  }

                  alert(response.body.message);
                  PopupStore.setMail2(false);
                  if (props.report) {
                    if (props.statusCondition === "Shortlist") {
                      await RecuiterStore.ChangeApplicantStatus(
                        props.status,
                        props.statusNumber,
                      );
                      await RecuiterStore.fetchApplicantDetails(applicantId);
                      await RecuiterStore.fetchJobPostApplications(id);
                    } else if (props.statusCondition === "Hire") {
                      await RecuiterStore.HireApplicant(
                        props.status,
                        props.statusNumber,
                      );
                      await RecuiterStore.fetchApplicantDetails(applicantId);
                    } else if (props.statusCondition === "Hold") {
                      await RecuiterStore.ChangeApplicantStatus(
                        props.status,
                        props.statusNumber,
                      );
                      await RecuiterStore.fetchApplicantDetails(applicantId);
                    }
                  }
                } else {
                  setLoader2(false);
                  alert(response.body.message);
                  await RecuiterStore.fetchApplicantDetails(applicantId);
                }
              }}
            >
              <LoaderForApplicants loader={loader2} />
              <AiFillCloseCircle
                className="text-primary absolute text-3xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />

              <span className="flex items-center gap-2 px-2 md:px-10 w-full">
                <span className="w-12 h-12 bg-primary2 rounded-full flex items-center justify-center">
                  <MdMailOutline className="w-6 h-6" />
                </span>
                <h1 className="text-lg font-semibold w-[90%] md:w-[70%]">
                  Send mail to {props.name} Candidates
                </h1>
              </span>
              <div className="  rounded-xl relative w-[95%] h-[90%]  ">
                <span className="py-0.5 flex items-center mx-[2.5%] border-b-2 w-[95%]">
                  <label className="text-black font-semibold w-10">To :</label>
                  <div
                    className="flex flex-row items-center w-[80%] overflow-x-scroll h-14 gap-2 px-2"
                    style={{
                      scrollbarWidth: "none",
                    }}
                  >
                    {Array.isArray(emailList) &&
                      emailList?.map((mail, index) => (
                        <span
                          key={index}
                          className={`px-3 py-1 my-3  rounded-lg border relative text-sm text-[#838383]${
                            close === index
                              ? "border border-primary text-primary"
                              : ""
                          }`}
                          onMouseEnter={() => {
                            setClose(index);
                          }}
                          onMouseLeave={() => setClose("")}
                        >
                          <AiFillCloseCircle
                            className="text-primary md:hidden z-50 absolute text-xl cursor-pointer  -top-2 -right-2"
                            onClick={() => {
                              setEmailList(emailList.filter((e) => e !== mail));
                            }}
                          />
                          {close === index ? (
                            <AiFillCloseCircle
                              className="text-primary z-50 absolute text-xl cursor-pointer  -top-1 -right-[5px]"
                              onClick={() => {
                                setEmailList(
                                  emailList.filter((e) => e !== mail),
                                );
                              }}
                            />
                          ) : (
                            <></>
                          )}

                          {mail}
                        </span>
                      ))}
                  </div>
                  <span className=" ml-2 ">
                    <button
                      type="button"
                      className="px-3 py-1 w-24 bg-orange-100 text-orange-500 rounded-lg text-sm"
                      onClick={() => {
                        const res = prompt("Enter Email ");
                        if (res) {
                          setEmailList([...emailList, res]);
                        }
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <AiFillPlusCircle className="text-primary  text-2xl" />
                        <span className="text-primary whitespace-nowrap text-xs">
                          Add Mail
                        </span>
                      </div>
                    </button>
                  </span>
                </span>
                <span className="py-0.5 flex items-center mx-[2.5%] border-b-2 w-[95%]">
                  <label className="text-black font-semibold w-10 whitespace-nowrap">
                    CC :
                  </label>
                  <div
                    className="flex flex-row items-center w-[80%] overflow-x-scroll h-14 gap-2 px-2"
                    style={{
                      scrollbarWidth: "none",
                    }}
                  >
                    {Array.isArray(cc) &&
                      cc?.map((mail, index) => (
                        <span
                          key={index}
                          className={`px-3 py-1 my-3  rounded-lg border relative text-sm text-[#838383]${
                            ccClose === index
                              ? "border border-primary text-primary"
                              : ""
                          }`}
                          onMouseEnter={() => {
                            setCcClose(index);
                          }}
                          onMouseLeave={() => setCcClose("")}
                        >
                          <AiFillCloseCircle
                            className="text-primary md:hidden z-50 absolute text-xl cursor-pointer  -top-2 -right-2"
                            onClick={() => {
                              setCc(cc.filter((e) => e !== mail));
                            }}
                          />
                          {ccClose === index ? (
                            <AiFillCloseCircle
                              className="text-primary z-50 absolute text-xl cursor-pointer  -top-1 -right-[5px]"
                              onClick={() => {
                                setCc(cc.filter((e) => e !== mail));
                              }}
                            />
                          ) : (
                            <></>
                          )}

                          {mail}
                        </span>
                      ))}
                  </div>
                  <span className=" ml-2 ">
                    <button
                      type="button"
                      className="px-3 py-1 w-24 bg-orange-100 text-orange-500 rounded-lg text-sm"
                      onClick={() => {
                        const res = prompt("Enter Email ");
                        if (res) {
                          setCc([...cc, res]);
                        }
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <AiFillPlusCircle className="text-primary  text-2xl" />
                        <span className="text-primary whitespace-nowrap text-xs">
                          Add Mail
                        </span>
                      </div>
                    </button>
                  </span>
                </span>
                <span className=" py-1 flex items-center mx-[2.5%]  w-[95%]">
                  <label className="text-black font-semibold">Subject</label>
                  <input
                    name="sub"
                    id="sub"
                    type="text"
                    defaultValue={props.sub}
                    className="w-[80%] ml-4 focus:outline-none"
                  />
                </span>
                <textarea
                  className=" resize-none  w-[95%] h-[70%] overflow-y-auto mx-[2.5%] focus:outline-none  "
                  style={{ scrollbarWidth: "none" }}
                  name="message"
                  id="message"
                  defaultValue={props.mess}
                />
              </div>
              <div className="w-[80%] flex ml-8 mr-auto md:mt-2 ">
                <button
                  type="submit"
                  className="px-4 bg-primary text-white py-1 rounded-lg "
                >
                  Send Mail
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : null}
    </>
  ));
}
